import { ActionType, createAsyncAction } from "typesafe-actions";

import { OnlyRequiredFields } from "@mapmycustomers/shared";
import FileTag from "@mapmycustomers/shared/types/entity/FileTag";

import { FileTagPayload } from "@app/store/api/ApiService";

import { ViewState } from ".";

export const initialize = createAsyncAction(
  "settings/fileTags/initialize/request",
  "settings/fileTags/initialize/success",
  "settings/fileTags/initialize/failure"
)<void, { fileTags: FileTag[]; total: number }, void>();

export const fetchFileTags = createAsyncAction(
  "settings/fileTags/fetchFileTags/request",
  "settings/fileTags/fetchFileTags/success",
  "settings/fileTags/fetchFileTags/failure"
)<ViewState, { fileTags: FileTag[]; total: number }, void>();

export const bulkCreateFileTags = createAsyncAction(
  "settings/fileTags/bulkCreateFileTags/request",
  "settings/fileTags/bulkCreateFileTags/success",
  "settings/fileTags/bulkCreateFileTags/failure"
)<{ callback?: () => void; fileTags: FileTagPayload[] }, void, void>();

export const bulkEditFileTags = createAsyncAction(
  "settings/fileTags/bulkEditFileTags/request",
  "settings/fileTags/bulkEditFileTags/success",
  "settings/fileTags/bulkEditFileTags/failure"
)<{ callback?: () => void; fileTags: OnlyRequiredFields<FileTag, "id">[] }, void, void>();

export const bulkDeleteFileTags = createAsyncAction(
  "settings/fileTags/bulkDeleteFileTags/request",
  "settings/fileTags/bulkDeleteFileTags/success",
  "settings/fileTags/bulkDeleteFileTags/failure"
)<{ callback?: () => void; ids: FileTag["id"][] }, void, void>();

export type Actions = ActionType<
  | typeof bulkCreateFileTags
  | typeof bulkDeleteFileTags
  | typeof bulkEditFileTags
  | typeof fetchFileTags
  | typeof initialize
>;
